import {CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree} from '@angular/router';
import { inject } from '@angular/core';
import { AppRoutes } from './app-routes';

export const ScreenGuard: CanActivateFn = (route:ActivatedRouteSnapshot,  state: RouterStateSnapshot): true | UrlTree => {
  const router = inject(Router);
  if(window.screen.availWidth < 1200) {
    if (state.url === AppRoutes.SMALL_SCREEN) {
      return true;
    } else {
      return router.createUrlTree([AppRoutes.SMALL_SCREEN]);
    }
  }
  return true;
};
